@if (isQuestionnairesExist || isGroupedScreeningQuestionsExist || isReferralQuestionsExist) {
  <div layout-vertical gap-small>
    @if (isQuestionnairesExist) {
      <rt-collapsible-card
        rtCollapsibleCardAnalytics
        analyticsKey="questionnaires"
        [uniqKey]="'candidate-questionnaires:' + questionnaire!.openQuestionAnswers[0].id"
        hasHeaderDivider="true"
      >
        <div leftSlot class="left-slot" layout min-width-0>
          <rt-heading white-space-no-wrap>
            {{ this.translations.titles.questionnaires | translate }}
          </rt-heading>
          <rt-truncate min-width-0 text-bold>{{ '• ' + questionnaire!.offer!.title }}</rt-truncate>
        </div>
        <div rightSlot layout layout-align-items-center>
          @let date = questionnaire!.updatedAt || questionnaire!.createdAt!;
          {{ date | amDateFormat: 'll' }}&nbsp;(<rt-date [time]="date"></rt-date>)
        </div>
        <div collapsible layout-full-width>
          <rt-candidate-questions-result
            [mode]="QuestionsMode.Questionnaires"
            [data]="questionnaire!"
            [visibilityTplRef]="visibilityTplRef"
          >
          </rt-candidate-questions-result>
        </div>
      </rt-collapsible-card>
    }
    @if (isGroupedScreeningQuestionsExist) {
      <rt-collapsible-card
        rtCollapsibleCardAnalytics
        analyticsKey="screeningQuestions"
        [uniqKey]="
          'candidate-screening-questions:' + groupedScreeningQuestions!.openQuestionAnswers[0].id
        "
        hasHeaderDivider="true"
      >
        <div leftSlot class="left-slot" layout min-width-0>
          <rt-heading white-space-no-wrap>
            {{ this.translations.titles.questions | translate }}
          </rt-heading>
          @if (shouldShowOfferTitle) {
            <rt-truncate min-width-0 text-bold>
              <rt-offer-status-indicator
                [offerStatus]="
                  $any({
                    status: groupedScreeningQuestions!.offer!.status,
                    kind: 'job',
                  })
                "
                margin-lr-small-xx
              ></rt-offer-status-indicator>
              {{ groupedScreeningQuestions!.offer!.title }}
            </rt-truncate>
          }
        </div>
        <div rightSlot layout layout-align-items-center>
          @let date = groupedScreeningQuestions!.updatedAt || groupedScreeningQuestions!.createdAt!;
          {{ date | amDateFormat: 'll' }}&nbsp;(<rt-date [time]="date"></rt-date>)
        </div>
        <div collapsible layout-full-width>
          <rt-candidate-questions-result
            [mode]="QuestionsMode.GroupedScreeningQuestions"
            [data]="groupedScreeningQuestions!"
            [visibilityTplRef]="visibilityTplRef"
            [hasBooleanFlagAnswers]="true"
          >
          </rt-candidate-questions-result>
        </div>
      </rt-collapsible-card>
    }
    @if (isReferralQuestionsExist) {
      <rt-collapsible-card
        rtCollapsibleCardAnalytics
        analyticsKey="referralQuestions"
        [uniqKey]="'candidate-referral-questions' + referralQuestions!.openQuestionAnswers[0].id"
        hasHeaderDivider="true"
      >
        <div leftSlot class="left-slot" layout min-width-0>
          <rt-heading white-space-no-wrap>
            {{ this.translations.titles.referralQuestions! | translate }}
          </rt-heading>
          <rt-truncate min-width-0 text-bold>
            {{ '• ' }}
            {{ translations.referralQuestions!.referredBy | translate }}
            @let user = referralQuestions!.user;
            @if (!user || user.anonymizedAt) {
              <rt-avatar
                [type]="'icon'"
                [size]="'small-x'"
                [shape]="'oval'"
                context="admin"
                iconName="person"
                class="referrer-avatar"
                margin-lr-small-xx
              ></rt-avatar>
              {{ translations.referralQuestions!.deletedReferrer | translate }}
            }
            @if (user && !user.anonymizedAt) {
              <rt-avatar
                [type]="user.hasAvatar ? 'image' : 'initials'"
                [size]="'small-x'"
                [shape]="'oval'"
                [imageSrc]="user.avatarThumbUrl"
                [initials]="user.initials"
                [fontSize]="'small'"
                class="referrer-avatar"
                margin-lr-small-xx
              ></rt-avatar>
              {{ user.firstName }} {{ user.lastName }}
            }
            {{ ' ' + (translations.referralQuestions!.for | translate) + ' ' }}
            {{ referralQuestions!.offer!.title }}
          </rt-truncate>
        </div>
        <div rightSlot layout layout-align-items-center>
          @let date = referralQuestions!.updatedAt || referralQuestions!.createdAt!;
          {{ date | amDateFormat: 'll' }}&nbsp;(<rt-date [time]="date"></rt-date>)
        </div>
        <div collapsible layout-full-width>
          <rt-candidate-questions-result
            [mode]="QuestionsMode.ReferralQuestions"
            [data]="referralQuestions!"
            [visibilityTplRef]="visibilityTplRef"
          >
          </rt-candidate-questions-result>
        </div>
      </rt-collapsible-card>
    }
  </div>
}
